import { ComplianceCheckExpiryConfigDto, ComplianceCheckExpiryConfigUpdateDto } from 'types/compliance';
import { portalAPI } from './portalAPI';

const APIComplianceCheckExpirySlice = portalAPI
    .enhanceEndpoints({ addTagTypes: ['ComplianceCheckExpiry'] })
    .injectEndpoints({
        endpoints: (builder) => ({
            getCheckExpiryConfigurations: builder.query<ComplianceCheckExpiryConfigDto[], void>({
                query: () => '/v1/compliance/check-expiry-configurations',
                providesTags: ['ComplianceCheckExpiry'],
            }),
            updateCheckExpiryConfiguration: builder.mutation<
                ComplianceCheckExpiryConfigDto,
                { id: number } & ComplianceCheckExpiryConfigUpdateDto
            >({
                query: ({ id, ...body }) => ({
                    url: `/v1/compliance/check-expiry-configurations/${id}`,
                    method: 'PUT',
                    body,
                }),
                invalidatesTags: ['ComplianceCheckExpiry'],
            }),
        }),
        overrideExisting: false,
    });

export const { useGetCheckExpiryConfigurationsQuery, useUpdateCheckExpiryConfigurationMutation } =
    APIComplianceCheckExpirySlice;
